// Pre-hearing lawful-use acknowledgement (Sprint battle-ready, Phase 5.4).
// Tracked per session in sessionStorage so the consent checklist appears once
// per hearing session, on the first attempt to start listening — not on every
// start/stop. Cleared when the tab closes, so a fresh session re-prompts.

const PREFIX = 'cc_prehearing_ack::';

export function isPreHearingAcked(sessionId: string | null): boolean {
  if (!sessionId) {
    return false;
  }
  try {
    return window.sessionStorage.getItem(PREFIX + sessionId) === '1';
  } catch {
    return false;
  }
}

export function markPreHearingAcked(sessionId: string | null): void {
  if (!sessionId) {
    return;
  }
  try {
    window.sessionStorage.setItem(PREFIX + sessionId, '1');
  } catch {
    // sessionStorage unavailable; the modal will simply appear again.
  }
}
